const ShimmerCardGrid = ({ count = 8 }) => {
  return (
    <div className="container mx-auto px-4 sm:px-6 md:px-10 animate-pulse">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
        {[...Array(count)].map((_, i) => (
          <div
            key={i}
            className="flex flex-col bg-white rounded-[10px] overflow-hidden"
          >
            {/* Image */}
            <div className="aspect-product-desktop w-full bg-slate-200"></div>

            {/* Content */}
            <div className="p-2 md:px-3 space-y-2">
              {/* Title */}
              <div className="h-3 w-3/4 bg-slate-200 rounded"></div>
              <div className="h-3 w-1/2 bg-slate-200 rounded"></div>

              {/* Price */}
              <div className="flex gap-2">
                <div className="h-3 w-12 bg-slate-200 rounded"></div>
                <div className="h-3 w-16 bg-slate-200 rounded"></div>
              </div>

              {/* Buttons */}
              <div className="flex gap-2 mt-2">
                <div className="flex-1 h-8 bg-slate-200 rounded"></div>
                <div className="h-8 w-8 bg-slate-200 rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShimmerCardGrid;